import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SharePage() {
    const { shareId } = useParams();
    const [share, setShare] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        setShare(null);
        setError(false);
        axios.get(`${API}/share/${shareId}`)
            .then((r) => setShare(r.data))
            .catch(() => setError(true));
    }, [shareId]);

    return (
        <div data-testid="share-page" className="min-h-screen bg-[#1C1E1D] text-[#FAF9F6] flex flex-col">
            <header className="py-6 px-6 md:px-12 flex items-center justify-between">
                <Link to="/" className="font-serif-lux text-2xl tracking-wide">
                    CM <span className="text-[#B89C6A]">RENOV</span>
                </Link>
                <span className="tracking-luxe text-[#B89C6A] text-[10px] hidden sm:block">Rénovation & Construction · Paris</span>
            </header>

            <main className="flex-1 flex flex-col items-center justify-center px-6 pb-16">
                {error && (
                    <div className="text-center">
                        <p className="font-serif-lux text-3xl mb-4">Ce partage n'existe plus.</p>
                        <Link to="/" className="inline-flex justify-center items-center px-7 py-3.5 bg-[#B89C6A] text-[#1C1E1D] text-[11px] font-medium tracking-[0.18em] uppercase hover:bg-[#FAF9F6] transition-colors">Découvrir CM RENOV →</Link>
                    </div>
                )}

                {!share && !error && (
                    <div className="w-8 h-8 border-2 border-[#B89C6A] border-t-transparent rounded-full animate-spin" />
                )}

                {share && (
                    <div className="w-full max-w-4xl">
                        <div className="text-center mb-8">
                            <div className="flex items-center justify-center gap-3 mb-4">
                                <span className="h-px w-10 bg-[#B89C6A]" />
                                <span className="tracking-luxe text-[#B89C6A]">Avant → Après · Projection IA</span>
                                <span className="h-px w-10 bg-[#B89C6A]" />
                            </div>
                            <h1 className="font-serif-lux text-3xl md:text-4xl">
                                Une pièce <em className="italic text-[#B89C6A]">réimaginée</em> par CMRENOV AI.
                            </h1>
                            <p className="mt-3 text-[13px] text-[#FAF9F6]/60">Glissez le curseur pour comparer.</p>
                        </div>

                        <div className="border border-[#B89C6A]/30" data-testid="share-slider">
                            <ReactCompareSlider
                                itemOne={<ReactCompareSliderImage src={`data:${share.before_mime};base64,${share.before_base64}`} alt="Avant" />}
                                itemTwo={<ReactCompareSliderImage src={`data:${share.after_mime};base64,${share.after_base64}`} alt="Après" />}
                            />
                        </div>

                        <p className="mt-4 text-center text-[11px] text-[#FAF9F6]/40 italic">
                            Rendu illustratif généré par intelligence artificielle · non contractuel.
                        </p>

                        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
                            <Link to="/cmrenov-ai" data-testid="share-cta-try"
                                className="inline-flex justify-center items-center px-7 py-3.5 bg-[#B89C6A] text-[#1C1E1D] text-[11px] font-medium tracking-[0.18em] uppercase hover:bg-[#FAF9F6] transition-colors">
                                Essayez sur votre pièce — 2 rendus offerts ✨
                            </Link>
                            <Link to="/#devis" data-testid="share-cta-quote"
                                className="inline-flex justify-center items-center px-7 py-3.5 border border-[#FAF9F6]/40 text-[#FAF9F6] text-[11px] font-medium tracking-[0.18em] uppercase hover:border-[#B89C6A] hover:text-[#B89C6A] transition-colors">
                                Estimer mon projet de rénovation →
                            </Link>
                        </div>
                    </div>
                )}
            </main>

            <footer className="py-6 text-center text-[11px] text-[#FAF9F6]/40">
                CM RENOV · 61 Avenue de Breteuil, 75007 Paris · contact@cmrenov.com
            </footer>
        </div>
    );
}
